module.exports = __webpack_public_path__ + "img/rings-wedding.a8aba90d.svg";